import { IButtonStyles, IIconProps, IconButton } from '@fluentui/react';
import React from 'react';

interface IScrollPaddleProps {
  icon: string;
  onClick: Function;
}

const buttonStyle: IButtonStyles = {
  root: {
      borderRadius: '50%',
      backgroundColor: 'white',
      margin: '0 15px',
      width: '2.5em',
  },
};

export const Internal__ImageBrowser_ScrollPaddle: React.FunctionComponent<IScrollPaddleProps> = (props) => {
  const iconProps: IIconProps = { iconName: props.icon };



  return (
    <IconButton iconProps={iconProps} onClick={e => props.onClick()} styles={buttonStyle} />
  );
};
